/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-concat */
import React, { useState, useEffect, useRef } from 'react';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import Box from '@mui/material/Box';
import { Paper } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  { field: 'RMA', headerName: 'RMA', width: 450, headerAlign: 'left', align: 'left' },
  { field: 'KitItems', headerName: 'Kit Items', valueFormatter: ({ value }) => `${(value).valueOf()}` + '\t', width: 550, type: 'string', headerAlign: 'left', align: 'left' },
  { field: 'Quantity', headerName: 'Quantity', width: 450, type: 'Date', headerAlign: 'left', align: 'left' },
];

const BlanketRMA = () => {
  const strt = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(strt);
  const [tableData, setTableData] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        InboundTable();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(strt); // for compulsory dates
    }
  }, [startDate, endDate]);

  const InboundTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID'))?.UserId || null,
      ProcessName: 'SimpliSafePortal',
      PageName: 'Blanket RMA',
      FromDate: startDate,
      ToDate: endDate,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(`${variables.BASE_URL}BlanketRMA`, requestOptions)
      .then(async (response) => {
        if (!response.ok) {
        // Explicitly handle HTTP error
          const errText = await response.text();
          throw new Error(`HTTP ${response.status} - ${errText}`);
        }
        return response.text();
      })
      .then((result) => {
        const parsedResult = JSON.parse(result);
        if (parsedResult?.IsSuccess && parsedResult?.IsAuthorize) {
          setTableData(parsedResult.BlanketRMA);
        } else if (!parsedResult?.IsSuccess && parsedResult?.IsAuthorize) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'No Data available for this Date!',
          });
          setTableData([]);
        } else if (!parsedResult?.IsAuthorize) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }
      })
      .catch((error) => {
        // console.error('Fetch error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };

  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={InboundTable}
          />
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Blanket RMA"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlanketRMA;
